export const MODERN_STORAGE_KEY = 'mw_modern_lounge';
export const DARK_STORAGE_KEY = 'mw_lounge_dark_mode';
export const DARK_MODE_CHANGE_EVENT = 'mw-lounge-dark-mode-change';

export const isModernLoungeEnabled = () => true;

export const isLoungeDarkModeEnabled = () => {
  try {
    return localStorage.getItem(DARK_STORAGE_KEY) === 'on';
  } catch {
    return false;
  }
};

export const applyLoungeThemeClasses = (
  modernEnabled = isModernLoungeEnabled(),
  darkEnabled = isLoungeDarkModeEnabled()
) => {
  if (typeof document === 'undefined') return false;

  const shouldUseDark = modernEnabled && darkEnabled;
  document.body.classList.toggle('mw-modern-mode', modernEnabled);
  document.body.classList.toggle('mw-modern-dark-mode', shouldUseDark);

  if (modernEnabled) {
    document.documentElement.setAttribute('data-mw-modern', 'on');
  } else {
    document.documentElement.removeAttribute('data-mw-modern');
  }

  if (shouldUseDark) {
    document.documentElement.setAttribute('data-mw-dark', 'on');
  } else {
    document.documentElement.removeAttribute('data-mw-dark');
  }

  return shouldUseDark;
};

export const setLoungeDarkModeEnabled = (enabled: boolean) => {
  try {
    if (enabled) {
      localStorage.setItem(DARK_STORAGE_KEY, 'on');
    } else {
      localStorage.removeItem(DARK_STORAGE_KEY);
    }
  } catch {
    /* localStorage unavailable; still update this page's classes */
  }

  const applied = applyLoungeThemeClasses(isModernLoungeEnabled(), enabled);

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(DARK_MODE_CHANGE_EVENT, { detail: { enabled: applied } })
    );
  }

  return applied;
};

export const syncInAppBodyClass = () => {
  if (typeof document === 'undefined') return;

  let isInApp = false;
  try {
    isInApp = localStorage.getItem('access') === 'app';
  } catch {
    /* private mode — leave as default */
  }
  document.body.classList.toggle('mw-in-app', isInApp);
};
